module.exports = __webpack_public_path__ + "assets/export.7c7048a0.svg";